import { ContentStatus } from "typings";

export const getStatusText = (status: ContentStatus) =>
{
    if (status === 0)
    {
        return "New";
    }
    if (status === 1)
    {
        return "Working";
    }
    if (status === 16)
    {
        return "Ready";
    }
    if (status === 2)
    {
        return "Discontinued";
    }
    return "Unknown status";
};


// WEBPACK FOOTER //
// ./src/util/productStatus.ts